import type { Nullable } from "../../../../typescript"
import eightDirectionCharsLowerCase from "../../direction/eightDirectionCharsLowerCase"
import type { EntityId } from "../../entity/EntityId.type"
import type { TileGraphNode } from "./TileGraphNode.type"

export default function getEightTilePositionNeighborsL1IdList(
  node: TileGraphNode): Array<Nullable<EntityId>> {
  return eightDirectionCharsLowerCase.map(dir => node[dir]?.ents.l1.id())
}